import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useGetVideosQuery } from '../../features/video/videoApi'
import { useAddQuizMutation } from '../../features/quiz/quizApi'
import Layout from '../../components/Layout'
import swal from 'sweetalert'
import QuizField from '../../components/QuizField'


export default function AddQuiz() {
    const dispatch = useDispatch()
    const { isSuccess: isSuccessFetchVideos, data: videos } = useGetVideosQuery()

    const [addQuiz, { isSuccess: isSuccessAddQuiz }] = useAddQuizMutation()

    const [quizOption1, setQuizOption1] = useState()
    const [quizOption2, setQuizOption2] = useState()
    const [quizOption3, setQuizOption3] = useState()
    const [quizOption4, setQuizOption4] = useState()

    const [quizQuestion, setQuizQuestion] = useState("")

    const [videoTitle, setVideoTitle] = useState("")

    useEffect(() => {
        if (isSuccessAddQuiz) {
            swal("Successful", "Quiz add successful", "success");
        }
    }, [isSuccessAddQuiz, dispatch])


    function handleCreateNewQuiz(e) {
        e.preventDefault();

        addQuiz({
            question: quizQuestion,
            video_title: videoTitle?.split("$@")[0],
            video_id: videoTitle?.split("$@")[1],
            options: [quizOption1, quizOption2, quizOption3, quizOption4]
        })
    }

    return (
        <Layout>
            <section className='py-6 bg-primary'>
                <div className='mx-auto max-w-full px-5 lg:px-20'>
                    <form onSubmit={handleCreateNewQuiz} className='py-8'>
                        <div className="mb-6">
                            <label htmlFor="video_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Video</label>
                            <select type="text" id="video_id" onChange={e => setVideoTitle(e.target.value)} value={videoTitle} name="video_id" className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required >
                                <option selected value="">Select Video</option>
                                {isSuccessFetchVideos && videos?.length > 0 ? videos.map(video => <option key={video.id} value={video.title + "$@" + video.id}>{video.title}</option>) : <option>No video available</option>}
                            </select>
                        </div>

                        <div className='border my-4 rounded-md p-5'>
                            <div className='mb-4'>
                                <label htmlFor="quizQuestion" className="block mb-2 text-sm font-medium text-white">Write quiz question.</label>
                                <input type="text" value={quizQuestion} onChange={e => setQuizQuestion(e.target.value)} name="quizQuestion" placeholder='Enter quiz question.' className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                            </div>
                            <div className="grid grid-cols-12 gap-6">
                                <QuizField setQuizOption={setQuizOption1} id="1" />
                                <QuizField setQuizOption={setQuizOption2} id="2" />
                                <QuizField setQuizOption={setQuizOption3} id="3" />
                                <QuizField setQuizOption={setQuizOption4} id="4" />
                            </div>
                        </div>

                        <button type="submit" className="video-add-submit-btn text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2 text-center bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">Add Quiz</button>
                    </form>
                </div>
            </section>
        </Layout>
    )
}
